import { type FC } from "react";

import { Colors } from "@snapchat/snap-design-system";

import { POLYGON_FILL } from "./engagementFunnel.styles";
import { List, ListContainer, ListItem } from "./engagementFunnelLegend.styles";

export const EngagementFunnelLegend: FC = () => (
    <ListContainer>
        <List>
            <ListItem color={Colors.Black.V50}>Sessions</ListItem>
            <ListItem color={POLYGON_FILL}>Progression</ListItem>
            <ListItem color={Colors.Gray.V300}>% Retained</ListItem>
        </List>
    </ListContainer>
);
